<template>
    <div class="commoditySetting">
<div class="searchBox">
            <el-select v-model="params.kmctype" placeholder="请选择">
                <el-option v-for="item in shopType" :key="item.name" :label="item.name" :value="item.code"></el-option>
            </el-select>
            <el-select v-model="params.isdistribute" placeholder="请选择">
                <el-option v-for="item in generalizeStatus" :key="item.name" :label="item.name" :value="item.code"></el-option>
            </el-select>
            <el-input v-model.trim="params.kmcname" placeholder="输入商品名称"></el-input>
            <el-button @click.native="search">搜索</el-button>
        </div>
         <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="kmcname" label="商品名称" width="420">
                <template slot-scope="scope">
                    <div class="textImg">
                        <div class="imgBox">
                            <img v-lazy="scope.row.logourl" :alt="scope.row.kmcname">
                        </div>
                        <div class="titlePrice">
                            <p class="title">{{scope.row.kmcname}}</p>
                            <div class="price">
                                <span v-if="scope.row.feetype === 1">免费</span>
                                <span v-if="scope.row.feetype === 2">￥{{scope.row.saleprice}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="kmctypeText" label="商品类型" class-name="center"></el-table-column>
            <el-table-column prop="saleprice" label="价格" class-name="center">
                <template slot-scope="scope">
                    <div class="price">
                        ￥{{scope.row.saleprice}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="是否参与推广" class-name="center">
                <template slot-scope="scope">
                    <div class="joinExtension">
                        <span :class="{'extension': scope.row.isdistribute === 1}">{{scope.row.isdistributeText}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="directscope" label="直接/间接推广佣金" class-name="center">
                <template slot-scope="scope">
                    <div class="commission">
                        <p>直接佣金比例: <span class="proportion">{{scope.row.directscope}}</span>%</p>
                        <p>间接佣金比例: <span class="proportion">{{scope.row.secondscope}}</span>%</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="action" label="操作" class-name="right">
                <template slot-scope="scope">
                    <div class="action">
                        <span @click="proportionSetting(scope.row)">比例设置</span>
                        <span class="line">|</span>
                        <span @click="posterSetting(scope.row)">海报设置</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Page :total="total" ref="page" @getList="getList"></Page>
        <ProportionSetting ref="proportionSetting" @getList="getList"></ProportionSetting>
        <PosterSetting ref="posterSetting"></PosterSetting>
    </div>
</template>
<script>
import Page from '@/base/page/page'
import ProportionSetting from './commoditySetting/proportionSetting'
import PosterSetting from './commoditySetting/posterSetting'
import {getCommoditySetList} from '@/api/distribution'
import {mapGetters, mapActions} from 'vuex'
export default {
name: 'commoditySetting',
    data() {
        return {
            shopType: [
                {code: '', name: '全部商品类型'},
                {code: '1', name: '图文'},
                {code: '2', name: '报告'},
                {code: '4', name: '视频'},
                {code: '3', name: '直播'},
                {code: '5', name: '专题'}
            ],
            generalizeStatus: [
                {code: '', name: '全部推广状态'},
                {code: '1', name: '参与'},
                {code: '0', name: '未参与'}
            ],
            params: {
                kmctype: '',
                isdistribute: '',
                kmcname: ''
            },
            tableData: [],
            total: 0
        }
    },
    created() {
    },
    mounted() {
        this.getList()
    },
    methods: {
        proportionSetting(row) {
            this.$refs.proportionSetting.openDialog(row)
        },
        posterSetting(row) {
            this.$refs.posterSetting.openDialog(row)
        },
        getList() {
            this.setLoading(true)
            let page = this.$refs.page.page
            getCommoditySetList({
                data: Object.assign({}, page, this.params),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        search() {
            this.getList()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        Page,
        ProportionSetting,
        PosterSetting
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
    .commoditySetting{
        .searchBox{
            margin-top: 20px;
            .el-select{
                width: 152px;
                margin-right: 30px;
                .el-input{
                width: 152px;
                    .el-input__suffix{
                        .el-input__suffix-inner{
                            .el-select__caret{
                                line-height: 32px;
                            }
                        }
                    }
                }
            }
            .el-input{
                width: 330px;
                margin-right: 30px;
            }
        }
        .el-table{
            margin-top: 30px;
            .textImg{
                display: flex;
                .imgBox{
                    img{
                        width: 106px;
                        height: 60px;
                    }
                }
                .titlePrice{
                    margin-left: 10px;
                    .title{
                        width: 304px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .price{
                        color: #F56C6C;
                        margin-top: 10px;
                    }
                }
            }
            .joinExtension{
                .extension{
                    color: #E6A23C;
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
            .right{
                .cell{
                    text-align: right;
                }
            }
            .commission{
                .proportion{
                    margin-left: 5px;
                }
            }
            .action{
                color: #409EFF;
                .line{
                    margin: 0 5px;
                }
                span{
                    cursor: pointer;
                }
            }
        }
    }
</style>